import {P2P, P2P_DETAIL} from "../config/paths/apiPaths";
import mapMarkers from "../config/enum/mapMarkers";

export default {
  namespaced: true,

  state: {
    startStop: null,
    endStop: null,
    results: [],
    detail: null,
    display: 'list',
  },

  mutations: {
    setStop(state, {field, stop}) {
      console.log(state, stop);

      state[field] = stop;

      console.log(state, stop);
    },
    setP2pResult(state, results) {
      state.results = results;
    },
    setP2pDetail(state, detail) {
      state.detail = detail;
      state.display = 'detail';
    },
    showP2pList(state) {
      state.display = 'list';
    }
  },

  actions: {
    async getP2pDetail({state, commit}, request) {
      const {startStop, endStop} = state;
      const response = await fetch(P2P_DETAIL, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          ...request,
          start: startStop,
          end: endStop,
        }),
      });

      const json = await response.json();

      commit('setP2pDetail', json.data);
      commit(
        'googleMap/setMarkers',
        json.data.stops.map(stop => {
          const {lat, lng} = stop;
          return {
            ...stop,
            position: {
              lat, lng,
            },
            markerIcon: mapMarkers.yellowIcon,
            infoWindowOpened: false,
          }
        }),
        {root: true},
      );
    },
    async getP2p({commit}, {start, end}) {
      const response = await fetch(P2P, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          start,
          end,
        }),
      });

      const json = await response.json();

      commit('setP2pResult', json.data);
      commit('showP2pList');

    },
  }
}
